export function extractUndefined<Parameter>(parameter: Parameter): Parameter extends undefined ? null : Parameter;
export function extractUndefined<Parameter>(parameter: Parameter): Parameter | null {
  return parameter ?? null;
}
